






















import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
// const Root = namespace("root");

@Component({})
export default class multiLangEnter extends Vue {
  // @Root.State languageList;
  @Prop({ default: () => {} }) content;
  @Prop({ default: () => [] }) languageList;
  @Prop({ default: false }) disabled;

  get icon() {
    let name = "multi-languages";
    if (this.isAllMultiLang()) {
      name = "multi-languages_2";
    }
    return name;
  }

  isAllMultiLang() {
    return this.languageList.every(_ => {
      let value = this.content[_.value];
      return !!value;
    });
  }
  clickIcon() {
    if (!this.disabled) {
      this.$emit("edit");
    }
  }
}
